const configuration = [
    {
        "aaryaadigital.com": {
            "REACT_APP_API_URL": "https://admin.aaryaadigital.com",
            "REACT_APP_APP_STORE_URL": "https://apps.apple.com/in/app/aaryaa-digital/id6502516384",
            "REACT_APP_PLAY_STORE_URL": "com.release.aryanews",
            "REACT_APP_LOGO": "https://ottimages.b-cdn.net/aaryaadigital/avatar/uhUZssLLvqTumCYay1TVdfgmE9kIrm2lJh1ExTo8.png",
            "REACT_APP_TITLE": "Aarya Digital - Watch TV Shows",
            "REACT_APP_YT": "https://www.youtube.com/@AaryaaDigital",
            "REACT_APP_IG": "https://www.instagram.com/aaryaadigital",
            "REACT_APP_FB": "https://www.facebook.com/profile.php?id=61559226250897",
            "REACT_APP_TT": "https://x.com/AaryaaDigital",
            "ANALYTIC_STRING" : '<script type="text/javascript" >(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");ym(98034598, "init", {clickmap:true,trackLinks:true,accurateTrackBounce:true,webvisor:true,ecommerce:"dataLayer"});</script><noscript><div><img src="https://mc.yandex.ru/watch/98034598" style="position:absolute; left:-9999px;" alt="" /></div></noscript>'
        },
        "localhost:3000": {
            "REACT_APP_API_URL": "https://backend.mahuaplay.com",
            // "REACT_APP_API_URL": "https://admin.aaryaadigital.com",
            "REACT_APP_APP_STORE_URL": "https://apps.apple.com/us/app/id6449380090",
            "REACT_APP_PLAY_STORE_URL": "https://play.google.com/store/apps/details?id=com.release.mitwatv",
            "REACT_APP_LOGO": "https://ottimages.b-cdn.net/mahuaplay/images/avatar/I07Yh344sEwgLuFiobbKXSjLTN637JuyX4rjsUqt.png",
            // "REACT_APP_LOGO": "https://ottimages.b-cdn.net/aaryaadigital/avatar/uhUZssLLvqTumCYay1TVdfgmE9kIrm2lJh1ExTo8.png",
            "REACT_APP_TITLE": "Aaryaa Digital - Watch TV Shows",
            "REACT_APP_YT": "https://www.youtube.com/@MahuaNetwork",
            "REACT_APP_IG": "https://www.instagram.com/mahuanetwork",
            "REACT_APP_FB": "https://www.facebook.com/mahuanetwork?mibextid=ZbWKwL",
            "REACT_APP_TT": "https://x.com/MahuaNetwork",

            "REACT_APP_FB_MAIN": "https://www.facebook.com/",
            "ANALYTIC_STRING" : ''

            // "REACT_APP_YT_MAIN":"https://www.youtube.com/",
            // "REACT_APP_IG_MAIN":"https://www.instagram.com/",                
            // "REACT_APP_TT_MAIN":"https://x.com/",
        },
        "qasite.ottsnap.com": {
            "REACT_APP_API_URL": "https://sadmin701.ottsanp.com",
            "REACT_APP_APP_STORE_URL": "https://apps.apple.com/in/app/",
            "REACT_APP_PLAY_STORE_URL": "",
            "REACT_APP_LOGO": "https://ottimages.b-cdn.net/aaryaadigital/avatar/uhUZssLLvqTumCYay1TVdfgmE9kIrm2lJh1ExTo8.png",
            "REACT_APP_TITLE": "QA - Test",
            "REACT_APP_YT": "",
            "REACT_APP_IG": "",
            "REACT_APP_FB": "",
            "REACT_APP_TT": "",
             "ANALYTIC_STRING" : '',

            "REACT_APP_FB_MAIN": "https://www.facebook.com/",
        },
        "mahuaplay.com": {
            "REACT_APP_API_URL": "https://backend.mahuaplay.com",
            "REACT_APP_APP_STORE_URL": "https://apps.apple.com/in/app/aaryaa-digital/id6502516384",
            "REACT_APP_PLAY_STORE_URL": "https://play.google.com/store/apps/details?id=com.release.mitwatv",
            // "REACT_APP_APP_STORE_URL": "https://apps.apple.com/us/app/id6449380090",
            // "REACT_APP_PLAY_STORE_URL": "com.release.mitwatv",
            "REACT_APP_LOGO": "https://ottimages.b-cdn.net/mahuaplay/images/avatar/I07Yh344sEwgLuFiobbKXSjLTN637JuyX4rjsUqt.png",
            "REACT_APP_TITLE": "Mahua Play",
            "REACT_APP_YT": "@MahuaNetwork",
            "REACT_APP_IG": "mahuanetwork",
            "REACT_APP_FB": "https://www.facebook.com/mahuanetwork?mibextid=ZbWKwL",
            "REACT_APP_TT": "x.com/MahuaNetwork",

            "REACT_APP_FB_MAIN": "https://www.facebook.com/",
            "ANALYTIC_STRING" : ''
        }
    },

]
window.CONFIGURATION = configuration;
export default configuration;



// "REACT_APP_YT": "https://youtube.com/@AaryaaDigital",
// "REACT_APP_IG": "https://www.instagram.com/aaryaadigital",
// "REACT_APP_FB":"61559226250897",
// "REACT_APP_TT":"https://twitter.com/AaryaaDigital",